const styles = (theme) => ({
    photo: {
        width: '100%',
        height: 'auto',
        position: 'relative',
    },
});

export default styles;
